/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Score_Legend_RtpInputs */



/**
* | output |
* | --- |
* | "Rating points from this event; your rank uses your best 8 results over 18 months." |
*
* @param {Score_Legend_RtpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const score_legend_rtp = /** @type {((inputs?: Score_Legend_RtpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Score_Legend_RtpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Points de rating de cet événement ; votre classement est basé sur vos 8 meilleurs tournois sur 18 mois.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Puntos de rating de este evento; su ranking se basa en sus mejores 8 torneos en 18 meses.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pontos de classificação deste evento; seu ranking se baseia nos seus melhores 8 torneios em 18 meses.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Punti rating da questo evento; il tuo ranking si basa sui tuoi migliori 8 tornei in 18 mesi.")
	return /** @type {LocalizedString} */ ("Rating points from this event; your rank uses your best 8 results over 18 months.")
});